import React from "react";
import "./style.scss";
import BillingDetails from "../../../components/Dashboard/BillingDetails";
const BillingDetailsPage = () => {
  return (
    <div className="billing_details_page_wrapper">
      <BillingDetails />
    </div>
  );
};

export default BillingDetailsPage;
